export default interface ISampleSettings {
    id: string;
    key: string;
    name: string;
    show: boolean;
}

export class SampleSettings implements ISampleSettings {
    id: string;
    key: string;
    name: string;
    show: boolean;

    constructor(id: string,
        key: string,
        name: string,
        show: boolean) {

        this.id = id;
        this.key = key;
        this.name = name;
        this.show = show;
    }
}

const defaultSampleSettingsData = new SampleSettings("", "", "", false);
export { defaultSampleSettingsData }